import regionTemplate from './region.template.html';
import applyDomScripts from './dom';

const registerTemplate = templateString => {
	const template = new DOMParser()
		.parseFromString(templateString, 'text/html')
		.querySelector('template');
	document.head.append(template);
	return template;
};

export const render = hostElement => {
	const template = registerTemplate(regionTemplate);
	hostElement.appendChild(template.content);
	applyDomScripts();
};
